import { Helmet } from "react-helmet-async";
import { SITE } from "@/site";

export const Seo = ({ title, description, path, jsonLd = [] }) => {
  const url = `${SITE.domain}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={SITE.title} />
      <meta name="twitter:card" content="summary" />
      {jsonLd.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export const physicianSchema = {
  "@context": "https://schema.org",
  "@type": ["Physician", "MedicalClinic", "LocalBusiness"],
  name: "Dr. Dixit — Gastroenterologist & Liver Specialist",
  medicalSpecialty: "Gastroenterology",
  telephone: "+919369698080",
  address: {
    "@type": "PostalAddress",
    streetAddress:
      "B 31/18-A-D-3, Rashmi Nagar Colony, behind V2 Mall, Saket Nagar Colony, Lanka",
    addressLocality: "Varanasi",
    addressRegion: "Uttar Pradesh",
    postalCode: "221005",
    addressCountry: "IN",
  },
  areaServed: ["Lanka", "Sunderpur", "BHU", "Varanasi"],
  url: SITE.domain,
};
